import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  openItem: ["dashboard"],
  defaultId: "dashboard",
  openComponent: "buttons",
  drawerOpen: typeof window !== "undefined" ? window.innerWidth >= 1024 : true,
  componentDrawerOpen: true,
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
    },
    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },
    openDrawer(state, action) {
      state.drawerOpen = action.payload.drawerOpen;
    },
    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    },
  },
});

export default menuSlice.reducer;
export const { activeItem, activeComponent, openDrawer, openComponentDrawer } = menuSlice.actions;
